export default __webpack_public_path__ + "static/media/1314 knife block B top.8d42c609.png";